import { useEffect, useState } from 'react'

export type Countdown = {
  days: number
  hours: number
  minutes: number
  seconds: number
  totalSeconds: number
  expired: boolean
}

// compte à rebours vers `expiresAt` (ISO), rafraîchi chaque seconde ; null sans échéance
export const useCountdown = (expiresAt: string | null): Countdown | null => {
  const [remainingMs, setRemainingMs] = useState(() => (expiresAt ? new Date(expiresAt).getTime() - Date.now() : 0))

  useEffect(() => {
    if (!expiresAt) return undefined
    const tick = () => setRemainingMs(new Date(expiresAt).getTime() - Date.now())
    tick()
    const interval = window.setInterval(tick, 1000)
    return () => window.clearInterval(interval)
  }, [expiresAt])

  if (!expiresAt) return null
  const totalSeconds = Math.max(Math.floor(remainingMs / 1000), 0)

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    totalSeconds,
    expired: totalSeconds === 0,
  }
}

export const pad2 = (value: number) => String(value).padStart(2, '0')
